export default "__VITE_ASSET__Hpi47cjB__"